/*
 * @Author: Jhony Reyes 
 * @Date: 2018-05-07 14:20:09 
 * @Last Modified by: Cesar Medina
 * @Last Modified time: 2019-10-30 11:40:05
 */

import React, { Component } from 'react';
import { Button, List } from 'antd';
import PropTypes from 'prop-types';
import { reverse } from 'lodash';
import { withTranslation } from 'react-i18next';

const defaultState = {
  checklist: {},
};

class Builder extends Component {
  constructor(props) {
    super(props);
    this.state = defaultState;
  }

  componentWillMount = () => {
    const { created } = this.props;
    this.setState({ checklist: created });
  }

  render() {
    const { checklist } = this.state;
    const { onDone, t } = this.props;
    const data = reverse(Object.values(checklist));

    return (
      <div>
        <span style={{ color: '#d60007', fontWeight: 'bold' }}>
          {t('added_tasks')}:
        </span>
        <List
          dataSource={data}
          style={{ maxHeight: '20rem', overflow: 'auto' }}
          locale={{ emptyText: t('no_data') }}
          renderItem={item => (
            <List.Item>
              {item.name}
            </List.Item>
          )}
        />
        <div className="justify-center margin-top-1">
          <Button
            className="margin-left-half-rem"
            type="primary"
            onClick={onDone}
          >
            {t('accept')}
          </Button>
        </div>
      </div>
    );
  }
}

Builder.propTypes = {
  onDone: PropTypes.func,
};

Builder.defaultProps = {
  onDone: () => {},
};

export default withTranslation()(Builder);
